var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import Vue from 'vue';
import ExprInput from "../../../../lib/builtin/designerComponents/ExprInput";
const headerStyle = {
  display: 'flex',
  'justify-content': 'space-between',
  'align-items': 'center',
  'margin-bottom': '16px'
};
let GlobalPluginsArgsSettingPanel = class GlobalPluginsArgsSettingPanel extends Vue {
  created() {
    this.args = this.plugin.args || '';
  }
  handleArgsChange(args) {
    this.$emit('change', {
      id: this.plugin.id,
      args
    });
  }
  handleDelete() {
    this.$emit('delete', this.plugin.id);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "style": "border: 1px solid #c8c8c8; padding: 16px"
    }, [h("div", {
      "style": headerStyle
    }, [h("p", {
      "style": 'margin-bottom: 0'
    }, [this.plugin.name || this.plugin.id]), h("button", {
      "class": "uc-button ucd-eventCard-btn",
      "on": {
        "click": this.handleDelete
      }
    }, [h("i", {
      "class": "fa fa-trash"
    }), " \u5220\u9664"])]), h(ExprInput, {
      "attrs": {
        "value": this.args
      },
      "on": {
        "change": this.handleArgsChange
      }
    })]);
  }
};
GlobalPluginsArgsSettingPanel = __decorate([Component({
  name: 'GlobalPluginsArgsSettingPanel',
  props: {
    plugin: Object
  },
  components: {
    ExprInput
  }
})], GlobalPluginsArgsSettingPanel);
export default GlobalPluginsArgsSettingPanel;
//# sourceMappingURL=globalPluginsArgsSettingPanel.js.map
